var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":"6Lf9KQYgAAAAAKbRjQjA8rTxDrugBnTC5vKmhsJ8"},on:{"verify":_vm.Verify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }